import {
    MutableRefObject,
    RefObject,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';
import cn from 'classnames';
import {
    Button,
    Checkbox,
    Element,
    Icon,
    Image,
    RouterLink,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { useSelector } from 'react-redux';
import useAuth from '@zmedia/bm-soccer-ui/hooks/useAuth';
import {
    authSelector,
    isLoggedSelector,
} from '@zmedia/bm-soccer-ui/selectors/auth';
import DropdownSetting from './dropdown';
import { useOutsideClick } from '@zmedia/bm-soccer-ui/hooks';
import { isIABMSelector } from '@zmedia/bm-soccer-ui/selectors/app';
import { ZaloLoginButton } from '@zmedia/bm-soccer-ui/modules/shared/components/buttons';
import styles from './styles.module.scss';

function UserProfile() {
    const { auth } = useAuth();
    const isLogged = useSelector(isLoggedSelector);
    const isIABM = useSelector(isIABMSelector);

    const authState = useSelector(authSelector);
    const [isExpand, setIsExpand] = useState<boolean>(false);
    const btnRef: MutableRefObject<any> = useRef<RefObject<any>>(null);
    const [checked, setChecked] = useState<boolean>(false);

    useEffect(() => {
        if (!isLogged) {
            auth();
        }
    }, [isLogged]);

    const handleClick = useCallback(() => {
        setIsExpand(!isExpand);
    }, [isExpand]);

    useEffect(() => {
        (window as any).authState = authState;
    }, [authState]);

    useOutsideClick([btnRef], (isExpand) => {
        if (!isExpand) {
            setIsExpand(false);
        }
    });

    const renderTriggerButton = useCallback(() => {
        if (!isLogged) {
            return <Icon icon="user" />;
        }
        return (
            <>
                <Image
                    src={authState.avatar}
                    alt={authState.displayName}
                ></Image>
            </>
        );
    }, [isLogged, authState]);

    const onChange = useCallback(() => {
        setChecked(!checked);
    }, [checked]);

    const renderDropdownContent = useCallback(() => {
        if (!isLogged) {
            return (
                <>
                    <DropdownSetting isLogged={false} />
                    <Element className={styles['login-dropdown']}>
                        <Title>Tài khoản</Title>
                        <Element className={styles.text}>
                            Bạn đồng ý với việc Đăng nhập/Đăng ký từ tài khoản
                            liên kết Zalo
                        </Element>
                        <Checkbox checked={checked} onChange={onChange}>
                            Tôi đã đọc và đồng ý với{' '}
                            <RouterLink
                                to="/staticpages/termsofuse.epi"
                                newTab
                                title=" Điều khoản sử dụng"
                            >
                                Điều khoản sử dụng
                            </RouterLink>{' '}
                            và{' '}
                            <RouterLink
                                to="/staticpages/privacy.epi"
                                newTab
                                title="Chính sách bảo mật"
                            >
                                Chính sách bảo mật
                            </RouterLink>
                        </Checkbox>
                        <Element className={checked ? '' : 'disabled'}>
                            <ZaloLoginButton />
                        </Element>
                    </Element>
                </>
            );
        }
        return <DropdownSetting />;
    }, [isLogged, checked]);

    if (isIABM) {
        return null;
    }

    return (
        <Element className={styles['user-profile']} domRef={btnRef}>
            <Button title="Thông tin" onClick={handleClick}>
                {renderTriggerButton()}
            </Button>
            <Element
                className={cn(styles['user-setting-dropdown'], {
                    [styles[`is-expand`]]: isExpand,
                })}
            >
                {renderDropdownContent()}
            </Element>
        </Element>
    );
}

export default UserProfile;
